import { DashboardHome } from '@/pages/DashboardHome'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$orgId/dashboard/home')({
  component: DashboardHome,
  meta: () => [{ title: 'Dashboard' }],
})
